import { FC, HTMLAttributes, memo } from 'react';
import cn from 'classnames';

import styles from './Specification.module.css';

export interface SpecificationProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
  title: string;
}

const Specification: FC<SpecificationProps> = (props) => {
  const { className, title, children, ...restProps } = props;

  return (
    <div {...restProps} className={cn(styles.tag, className)}>
      <div className={cn(styles.title, 'Specifications')}>{title}</div>
      {children}
    </div>
  );
};

export default memo(Specification);
